import type { ProductFormType } from "src/pages/Product/ProductForm/ProductForm.types";

export const isValidRecipeQuantity = (quantity: number | null | undefined): quantity is number =>
    typeof quantity === "number" && Number.isFinite(quantity) && quantity > 0;

export const getRecipeWeightValidation = (product: Pick<ProductFormType, "productIngredients" | "netWeight">) => {
    const { productIngredients, netWeight } = product;
    const totalWeight = productIngredients.reduce(
        (total, ingredient) => total + (isValidRecipeQuantity(ingredient.quantity) ? ingredient.quantity : 0),
        0,
    );
    const canCompare = productIngredients.length > 0 && isValidRecipeQuantity(netWeight);
    const difference = canCompare ? Math.abs(totalWeight - netWeight) : 0;
    const precision = Number.EPSILON * Math.max(1, totalWeight, netWeight ?? 0) * productIngredients.length;
    const hasWeightMismatch = canCompare && (!Number.isFinite(totalWeight) || difference > precision);
    const isConsistent =
        canCompare &&
        !hasWeightMismatch &&
        productIngredients.every((ingredient) => isValidRecipeQuantity(ingredient.quantity));

    return { totalWeight, difference, hasWeightMismatch, isConsistent };
};
